import styled from "@emotion/styled";
import { RequiredThemeKeys } from "../../../../util/theme";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";
import { TypeRampV2 } from "../../../typography";

const PLACEHOLDER_LEFT_WITH_CONTENTBEFORE = "40px";
const PLACEHOLDER_LEFT_DEFAULT = "12px";

interface SelectPlaceholderStyledProps {
    hasContentBefore: boolean;
    themeMode: RequiredThemeKeys;
}

export const SelectPlaceholderStyled = styled(TypeRampV2)<SelectPlaceholderStyledProps>`
    color: ${({ themeMode }) => formInputTheme.placeholderColor.hover(themeMode)};

    position: absolute;
    top: 11px;
    left: ${({ hasContentBefore }) =>
        hasContentBefore ? PLACEHOLDER_LEFT_WITH_CONTENTBEFORE : PLACEHOLDER_LEFT_DEFAULT};

    user-select: none;
    right: 30px;
    text-align: left;
    pointer-events: none;
`;
